module.exports = __webpack_public_path__ + "media/images/icon-storage-off@3x-f0980015be208e57b05ded8cd3103a8a.png";